import React from "react";
import {
	AppstoreFilled,
	BankFilled,
	BellFilled,
	BookFilled,
	CalendarFilled,
	CloudFilled,
	ContactsFilled,
	CrownFilled,
	DashboardFilled,
	DollarCircleFilled,
	FileFilled,
	FileTextFilled,
	FlagFilled,
	FolderFilled,
	GiftFilled,
	HeartFilled,
	HomeFilled,
	IdcardFilled,
	LockFilled,
	MailFilled,
	MobileFilled,
	NotificationFilled,
	PictureFilled,
	ProjectFilled,
	ReadFilled,
	SettingFilled,
	SnippetsFilled,
	StarFilled,
	TagsFilled,
	TrophyFilled,
	UsergroupAddOutlined,
	UserOutlined,
	TeamOutlined,
} from "@ant-design/icons";

type IconComponent = React.ComponentType;

const ICONS: Record<string, IconComponent> = {
	// Ant Design names (recommended)
	AppstoreFilled,
	BankFilled,
	BellFilled,
	BookFilled,
	CalendarFilled,
	CloudFilled,
	ContactsFilled,
	CrownFilled,
	DashboardFilled,
	DollarCircleFilled,
	FileFilled,
	FileTextFilled,
	FlagFilled,
	FolderFilled,
	GiftFilled,
	HeartFilled,
	HomeFilled,
	IdcardFilled,
	LockFilled,
	MailFilled,
	MobileFilled,
	NotificationFilled,
	PictureFilled,
	ProjectFilled,
	ReadFilled,
	SettingFilled,
	SnippetsFilled,
	StarFilled,
	TagsFilled,
	TrophyFilled,
	UsergroupAddOutlined,
	UserOutlined,
	TeamOutlined,

	// Legacy Font Awesome-style names found in existing seed data
	"user-circle": UserOutlined,
	user: UserOutlined,
	users: TeamOutlined,
	"id-badge": IdcardFilled,
	"id-card": IdcardFilled,
	flag: FlagFilled,
	building: BankFilled,
	square: AppstoreFilled,
	file: FileFilled,
	"file-alt": FileTextFilled,
	envelope: MailFilled,
	newspaper: ReadFilled,
	star: StarFilled,
	tags: TagsFilled,
	heart: HeartFilled,
	image: PictureFilled,
	mobile: MobileFilled,
	cloud: CloudFilled,
	folder: FolderFilled,
	bell: BellFilled,
	calendar: CalendarFilled,
	cog: SettingFilled,
	home: HomeFilled,
};

export const resolveMenuIcon = (iconName: string | null | undefined, fallback: React.ReactNode): React.ReactNode => {
	const key = iconName?.trim();
	if (!key) {
		return fallback;
	}

	const Icon = ICONS[key] ?? ICONS[key.toLowerCase()];
	return Icon ? <Icon /> : fallback;
};
